import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PricingProfileAction } from '../pricingProfile.action';

type IDependencies = IClientApiDependencySegment;

export const removePricingProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingProfileAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deletePricingProfile({ id: params.id }).pipe(
      mergeMap(() => {
        return [
          PricingProfileAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          PricingProfileAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
